// @flow
import { connect } from "react-redux";
import React, { forwardRef } from "react";
import t from "common/i18n";
import Button from "root/components/Button";
import { selectClientAllowedFormatsOptions } from "~/src/root/selectors";
import "./UploadButton.scss";

export const UploadButton = forwardRef((props, ref) => (
	<div className="upload_button_holder" ref={ref} >
		<input type="file" name="file" className="cloudinary_fileupload" accept={props.allowedFormat} tabIndex={-1} />
		<Button colorName="link" text={t("local.browse")} tabIndex={0} />
	</div>
));

const mapStateToProps = (state) => ({
	allowedFormat: selectClientAllowedFormatsOptions(state)
});

export default connect(mapStateToProps,null,null,{ forwardRef: true })(UploadButton);
